module.exports = __webpack_public_path__ + "img/frontend_base_eletromobilidade.91901f8d.jpg";